import { render, staticRenderFns } from "./BattleChip.vue?vue&type=template&id=b7f83e84&scoped=true"
import script from "./BattleChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./BattleChip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BattleChip.vue?vue&type=style&index=0&id=b7f83e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f83e84",
  null
  
)

export default component.exports